module.exports = __webpack_public_path__ + "img/12.f3dcbad3.png";